/**
* Alumni Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Alumni Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'alumni-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.alumni-marquee' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--alumni-marquee' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '32px',
          perPage: 3,
          perMove: 1,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'alumni-marquee', COMPONENT );
} )( app );
